import { render, staticRenderFns } from "./DeAsideContainer.vue?vue&type=template&id=a7085c30&scoped=true"
import script from "./DeAsideContainer.vue?vue&type=script&lang=js"
export * from "./DeAsideContainer.vue?vue&type=script&lang=js"
import style0 from "./DeAsideContainer.vue?vue&type=style&index=0&id=a7085c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7085c30",
  null
  
)

export default component.exports